<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">
      <section class="admin-content">
        <div class="bg-info m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-md-6 text-center mx-auto text-white">
                <div class="m-b-10">
                  <div class="avatar"></div>
                </div>
                <h3 class="h3 text-dark">Document Upload Form</h3>
              </div>
            </div>
          </div>
        </div>
        <section class="container">
          <div class="container">
            <div class="row list">
              <div class="col-lg-12 col-md-12">
                <div class="card m-b-30">
                  <div class="card-body">
                    <form @submit.prevent="singleClaim">
                      <div class="row">
                        <div class="form-group col-md-12">
                          <label for="inputCity"> Select Document Type</label>
                          <select class="form-control" v-model="document.name">
                            <option
                              :value="option"
                              v-for="option in options"
                              :key="option"
                            >
                              {{ option }}
                            </option>
                          </select>
                        </div>

                        <!-- <div class="form-group col-md-12" v-if="document.name == 'Others'">
                                   <label for="inputEmail4">Name of Document <span class="text-danger">*</span></label>
                                   <input type="text" class="form-control" v-model="document.name" placeholder="e.g Receipt for drugs, x-ray scan, letter of acceptance, etc">
                               </div> -->

                        <div
                          class="fileinput fileinput-new"
                          data-provides="fileinput"
                          v-if="document.name != ''"
                        >
                          <span class="btn btn-info btn-block btn-file">
                            <span class="fileinput-new"
                              ><i class="fe fe-upload"></i> Upload
                              Document</span
                            >
                            <span class="fileinput-exists">Change</span>
                            <input
                              type="file"
                              name="..."
                              multiple
                              v-on:change="attachPic"
                            />
                          </span>
                          <span class="fileinput-filename"></span>
                          <a
                            href="#"
                            class="close fileinput-exists"
                            data-dismiss="fileinput"
                            style="float: none"
                            >&times;</a
                          >
                        </div>
                      </div>
                    </form>

                    <div class="col-md-12">
                      <button
                        class="btn btn-outline-info btn-block"
                        @click="uploadPicture"
                      >
                        Submit
                        <i class="fe fe-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card col-md-12">
                <div class="table-responsive">
                  <table class="table align-td-middle table-card">
                    <thead>
                      <tr>
                        <th>Number</th>
                        <th>Name</th>
                        <th>Uploaded By</th>
                        <th>Date Uploaded</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(doc, index) in docs" v-bind:key="doc.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ doc.name }}</td>
                        <td>
                          {{ doc.user.firstname }} {{ doc.user.lastname }}
                        </td>
                        <td>{{ doc.created_at }}</td>
                        <td>
                          <a
                            :href="
                              'https://claimify-api.hayokmedicare.ng/documents/' +
                              doc.document
                            "
                            target="_blank"
                          >
                            <button class="btn btn-default" name="button">
                              <i class="fe fe-eye"></i>
                            </button>
                          </a>
                          <!-- <button
                        class="btn btn-danger"
                        name="button"
                        @click="deleteDoc(doc)"
                      >
                        <i class="fe fe-delete"></i>
                      </button> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      options: [
        "NHIA PHC Data Collection Tool",
        "Claims Document",
        "QA Document",
        "Others",
      ],
      doc_name: "",
      quantity: "",
      cost: "",
      singleservice: "",
      singledrug: "",
      claims: "",
      docs: "",
      document: {
        name: "",
        file: "",
      },
      edit: false,
      isLoading: false,
      fullPage: true,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    getDocuments() {

      this.user = JSON.parse(localStorage.getItem("user"));

      this.axios
        .get(`/api/v1/auth/all-documentsprovider/${this.user.institutional_id}`)
        .then((response) => {
          this.docs = response.data;
          console.log(response);
        });
    },

    clearIt() {
      this.document.name = "";
    },

    attachPic(event) {
      this.user = JSON.parse(localStorage.getItem("user"));
      console.log(event);
      this.image = event.target.files[0];
      // this.uploadPicture();
    },
    uploadPicture() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      let formData = new FormData();
      formData.append("agency_id", 90);
      formData.append("claim_document", this.image);
      formData.append("type", this.document.name);
      formData.append("provider_id", this.user.institutional_id);
      formData.append("doc_name", this.document.name);
      this.axios
        .post("/api/v1/auth/uploadDocument", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("uploaded Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.clearIt();
          this.getDocuments();
        })
        .catch((error) => {
          this.$toasted.error("Error Uploading", {
            position: "top-center",
            duration: 3000,
          });
          console.error(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getDocuments()
  },
};
</script>
